import {
  ProjectTopicFragmentFragment
} from '@lopo-tech/lopo-api'
import React from 'react'
import MasonryFeed from 'src/components/feed/layouts/masonry_feed/masonry_feed'
import { CLASS_PREFIX } from 'src/constants'
import FeedWrapper from 'src/containers/smart_components/list_wrapper/feed_wrapper'
import './project_feed.scss'

interface ProjectFeedProps {
  topics?: ProjectTopicFragmentFragment[] | null;
  getNextPage: () => void;
  loading: boolean;
}

const cls = `${CLASS_PREFIX}project-feed`

export const ProjectFeed: React.FC<ProjectFeedProps> = ({ topics, getNextPage, loading }) => {
  if (!topics || topics.length === 0) return null

  return (
    <div className={cls}>
      <FeedWrapper
        getNextPage={getNextPage}
        initialLoad={false}
      >
        <MasonryFeed items={topics[0].contentItems?.items ?? []} isLoading={loading} withBorder={true} />
      </FeedWrapper>
    </div>
  )
}
